import { render, staticRenderFns } from "./bulkPayment.vue?vue&type=template&id=20712d08&scoped=true&"
import script from "./bulkPayment.vue?vue&type=script&lang=js&"
export * from "./bulkPayment.vue?vue&type=script&lang=js&"
import style0 from "./bulkPayment.vue?vue&type=style&index=0&id=20712d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20712d08",
  null
  
)

export default component.exports